import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Permission, Role } from "../typeDefs/permissions";

export interface PermissionsState {
    roles: Role[];
    rolesLoading: boolean;
    users: string[];
    usersLoading: boolean;
    permissions: Permission[];
    permissionsLoading: boolean;
}

const initialState: PermissionsState = {
    roles: [],
    rolesLoading: false,
    users: [],
    usersLoading: false,
    permissions: [],
    permissionsLoading: false,
};

export const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setRoles: (state, action: PayloadAction<Role[]>) => {
            state.roles = action.payload;
        },
        setRolesLoading: (state, action: PayloadAction<boolean>) => {
            state.rolesLoading = action.payload;
        },
        setRoleUsers: (state, action: PayloadAction<string[]>) => {
            state.users = action.payload;
        },
        setRoleUsersLoading: (state, action: PayloadAction<boolean>) => {
            state.usersLoading = action.payload;
        },
        setPermissions: (state, action: PayloadAction<Permission[]>) => {
            state.permissions = action.payload;
        },
        setPermissionsLoading: (state, action: PayloadAction<boolean>) => {
            state.permissionsLoading = action.payload;
        },
    },
});

export const {
    setRoles,
    setRolesLoading,
    setRoleUsers,
    setRoleUsersLoading,
    setPermissions,
    setPermissionsLoading,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
